import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';
import { TranslateService } from '@ngx-translate/core';
import { ChartOfAccountsService } from '../../services/chartOfAccounts/chartOfAccounts.service';


@Component({
  selector: 'app-chart-of-account-form',
  templateUrl: './chart-of-account-form.component.html',
  styleUrls: ['./chart-of-account-form.component.scss']
})
export class ChartOfAccountFormComponent implements OnInit {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  userId:any;
  CompanyId: any;
  SelectedCompanyGSTCode: any;
  TenantId: any;
  @Output() OnRefreshParent = new EventEmitter<string>();

  Name: any = {
    lable: 'Account Name',
    placeholder: 'Enter the account name',
    dataField: 'Name',
    formControlName: 'Name',
    isRequired: true
  };
  ParentId: any =
    {
      lable: 'Parent Company',
      dropdownList: [],
      dataField: 'ParentId',
      formControlName: 'ParentId',
      placeholder: 'Select parent company',
      isValueBind: true,
      isSearchByApi: true,
      isRequired: true
    }
  AccountType: any =
    {
      lable: 'Account Type',
      dropdownList: [],
      dataField: 'AccountType',
      formControlName: 'AccountType',
      placeholder: 'Select Account Type',
      isValueBind: true,
      isRequired: true
    }

  Description: any = {
    lable: 'Service Description',
    placeholder: 'Write something about the service...',
    dataField: 'Description',
    formControlName: 'Description',
    type: 'textarea',
  };
  IsActive: any = {
    dataField: 'IsActive',
    formControlName: 'IsActive',
  };
  IsAuthorized: any = {
    dataField: 'IsMandatoryForOrder',
    formControlName: 'IsMandatoryForOrder',
  };

  data: any = {};
  ChartOfAccountsObjDetails: any = {};
  isFormSubmitY: boolean = false;
  isFormSubmit: boolean = false;
  isAuthorizedButtonEnabled : boolean =  false;

  accountTableDetails = {
    data: [
    ],
    columnDetails: [
      { columnName: "NewChartofAccounts.DefaultGroupfor", dataFieldName: 'isSelected', isCheckBox: true },
      { columnName: "NewChartofAccounts.Name", dataFieldName: 'Label' }
    ],
    isColumnNameShow: true,
  };

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router,
    private translate: TranslateService,
    private chartOfAccService: ChartOfAccountsService
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId")))
    );
    this.ChartOfAccountsObjDetails.CompanyId = JSON.parse(localStorage.getItem('ChnageCompnayId')).Id;
    this.ChartOfAccountsObjDetails.IsActive = true;
    this.GetDefaultsList();

    Promise.all([
      this.chartOfAccService.getAccountTypeList()
    ])
    .then((results) => {
      Helpers.setLoading(false);
      this.AccountType = { ...this.AccountType, dropdownList: this.chartOfAccService.accountTypeList };
      this.ParentId = { ...this.ParentId, dropdownList: this.chartOfAccService.parentAccountList }
    })
    .catch((error) => {
      Helpers.setLoading(false);
    });
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  changeActiveStatus(status: any) {
    this.ChartOfAccountsObjDetails.IsActive = status;
  }

  GetDefaultsList() {
    var listOfDefaults = [];
    listOfDefaults.push({
      isSelected: (this.ChartOfAccountsObjDetails.IsDefaultGroupForCustomer !== null && this.ChartOfAccountsObjDetails.IsDefaultGroupForCustomer !== undefined)
        ? this.ChartOfAccountsObjDetails.IsDefaultGroupForCustomer
        : false, Label: 'Customer'
    });
    listOfDefaults.push({
      isSelected: (this.ChartOfAccountsObjDetails.IsDefaultGroupForTransporter !== null && this.ChartOfAccountsObjDetails.IsDefaultGroupForTransporter !== undefined)
        ? this.ChartOfAccountsObjDetails.IsDefaultGroupForTransporter
        : false, Label: 'Transporter'
    });
    listOfDefaults.push({
      isSelected: (this.ChartOfAccountsObjDetails.IsDefaultGroupForVendor !== null && this.ChartOfAccountsObjDetails.IsDefaultGroupForVendor !== undefined)
        ? this.ChartOfAccountsObjDetails.IsDefaultGroupForVendor
        : false, Label: 'Vendor'
    });
    listOfDefaults.push({
      isSelected: (this.ChartOfAccountsObjDetails.IsDefaultGroupForDriver !== null && this.ChartOfAccountsObjDetails.IsDefaultGroupForDriver !== undefined)
        ? this.ChartOfAccountsObjDetails.IsDefaultGroupForDriver
        : false, Label: 'Driver'
    });
    listOfDefaults.push({
      isSelected: (this.ChartOfAccountsObjDetails.IsDefaultGroupForToll !== null && this.ChartOfAccountsObjDetails.IsDefaultGroupForToll !== undefined)
        ? this.ChartOfAccountsObjDetails.IsDefaultGroupForToll
        : false, Label: 'Toll'
    });
    listOfDefaults.push({
      isSelected: (this.ChartOfAccountsObjDetails.IsDefaultGroupForFuel !== null && this.ChartOfAccountsObjDetails.IsDefaultGroupForFuel !== undefined)
        ? this.ChartOfAccountsObjDetails.IsDefaultGroupForFuel
        : false, Label: 'Fuel'
    });
    this.accountTableDetails = { ...this.accountTableDetails, data: listOfDefaults };
    Helpers.setLoading(false);
  }

  selectRow(event) {
    console.log("row", event.row);
    switch (event.row.Label) {
      case 'Customer':
        this.ChartOfAccountsObjDetails.IsDefaultGroupForCustomer = event.row.isSelected;
        break;

      case 'Transporter':
        this.ChartOfAccountsObjDetails.IsDefaultGroupForTransporter = event.row.isSelected;
        break;

      case 'Vendor':
        this.ChartOfAccountsObjDetails.IsDefaultGroupForVendor = event.row.isSelected;
        break;

      case 'Driver':
        this.ChartOfAccountsObjDetails.IsDefaultGroupForDriver = event.row.isSelected;
        break;

      case 'Toll':
        this.ChartOfAccountsObjDetails.IsDefaultGroupForToll = event.row.isSelected;
        break;

      case 'Fuel':
        this.ChartOfAccountsObjDetails.IsDefaultGroupForFuel = event.row.isSelected;
        break;

      default:
        console.log('Default case selected');
        break;
    }
  }

  getChangedValue(value, dataFeild) {
    if (dataFeild === 'ParentId') {
      this.ChartOfAccountsObjDetails[dataFeild] = value.value;
    } else
      this.ChartOfAccountsObjDetails[dataFeild] = value;
  }

  getParentList(value, isScrollDown = false) {
    this.ParentId.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ParentId.dropdownList.length / 20) + 1;
    }
    this.chartOfAccService.getParentAccountList(value, pageNo).then(res => {
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.ParentId.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ParentId.dropdownList);
        this.ParentId = { ...this.ParentId, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ParentId = { ...this.ParentId, dropdownList: [...dropdownList] });
      this.ParentId.isSearch = false;
    }).catch(error => {
      this.ParentId.isSearch = false;
    })
  }

  saveChartOfAccounts() {
    this.isFormSubmit=true;
    if(!this.ChartOfAccountsObjDetails.Name){
      this.toastr.warning('Please select account name','Warning');
      return;
    }
    if(!this.ChartOfAccountsObjDetails.ParentId){
      this.toastr.warning('Please select parent company','Warning');
      return;
    }
    if(!this.ChartOfAccountsObjDetails.AccountType){
      this.toastr.warning('Please select account type','Warning');
      return;
    }
    console.log("saving obj", this.ChartOfAccountsObjDetails);
    Helpers.setLoading(true);
    if (!this.ChartOfAccountsObjDetails.CompanyId) {
    this.ChartOfAccountsObjDetails.CompanyId = JSON.parse(localStorage.getItem('ChnageCompnayId')).Id;
    }
    this._appService.GetByThreeId("ChartsofAccount","New_CheckAccountExist",this.ChartOfAccountsObjDetails.Id,this.ChartOfAccountsObjDetails.ParentId,this.ChartOfAccountsObjDetails.Name).subscribe(
      (response) => {
        if (response[0].ExistsFlag == false){
          this._appService.Post("ChartsofAccount", "SaveAccount", this.ChartOfAccountsObjDetails).subscribe(
            (response) => {
              Helpers.setLoading(false);
              this.toastr.success("Data saved Successfully !", "Success");
              console.log("Returned Save Data :",response);
              this.ChartOfAccountsObjDetails.Id = response.Id;
              this.isAuthorizedButtonEnabled = true;
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("Error occurred while saving data !","Error");
            }
          );
        }else{
          Helpers.setLoading(false);
          this.toastr.error("The Account is already Exists !", "Error");
        }
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("The Account is already Exists !", "Error");
      }
    );
  }

  onAuthorize() {
    Helpers.setLoading(true);
    this._appService.GetByThreeId("Common","AuthorizeTransaction",10,this.ChartOfAccountsObjDetails.Id,this.CompanyId).subscribe(
      (response) => {
        this.toastr.success("Account Authorized Successfully !", "Success");
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error("An error occured printing !", "Error");
        Helpers.setLoading(false);
      }
    );
  }
}
